/* eslint-disable */
import { Injectable } from '@angular/core';
import { States } from '../models/SelectOptions/States';
import { Countries } from '../models/SelectOptions/Countries';
import { DepositFrequencies, Frequency } from '../models/SelectOptions/DepositFrequencies';
import { OptionYears, OptionAnnualTrades, OptionAverageTradeSize } from '../models/SelectOptions/Options';
import { StockYears, StockAnnualTrades, StockAverageTradeSize } from '../models/SelectOptions/Stocks';
import { LiquidityNeeds } from '../models/SelectOptions/LiquidityNeeds';
import { TimeHorizon } from '../models/SelectOptions/TimeHorizon';
import { Relationship } from '../models/SelectOptions/Relationship';
import { TKACashAllocation } from '../models/SelectOptions/TKACashAllocation';
import { TKATimeHorizons } from '../models/SelectOptions/TKATimeHorizons';
import { TKAGoal } from '../models/SelectOptions/TKAGoal';
import { TKARetirement } from '../models/SelectOptions/TKARetirement';
import { TKARiskTolerance } from '../models/SelectOptions/TKARiskTolerance';
import { TKAStrategyType } from '../models/SelectOptions/TKAStrategyType';

import * as _ from 'lodash';

@Injectable()
export class SelectOptionsService {

  constructor() {
    this.optionTypes = {
      // Locations
      state: States,
      country: Countries,

      depositFrequencies: DepositFrequencies,
      frequency: Frequency,

      // Options
      optionYears: OptionYears,
      optionAnnualTrades: OptionAnnualTrades,
      optionAverageTradeSize: OptionAverageTradeSize,

      // Stocks
      stockYears: StockYears,
      stockAnnualTrades: StockAnnualTrades,
      stockAverageTradeSize: StockAverageTradeSize,

      liquidityNeeds: LiquidityNeeds,
      timeHorizon: TimeHorizon,

      // Questionnaire
      tkaCashAllocation: TKACashAllocation,
      tkaTimeHorizons: TKATimeHorizons,
      tkaGoal: TKAGoal,
      tkaRetirement: TKARetirement,
      tkaRiskTolerance: TKARiskTolerance,
      tkaStrategyType: TKAStrategyType,

      relationship: Relationship
    };
  }

  isValidOption(type, id) {
    const options = this.getSelectOptions(type);

    if (options == null) return false;
    return _.find(options, q => (q.id == id || q.code == id)) !== undefined;
  }

  getSelectOptions(type) {
    if (this.optionTypes[type] === undefined) return [];
    return this.optionTypes[type];
  }

  getCode(type, value) {
    return this._getCodeProperty(type, value, 'name', 'code');
  }

  getCodeName(type, code) {
    return this._getCodeProperty(type, code, 'code', 'name');
  }

  _getCodeProperty(type, value, property, returnProperty) {
    const optionValues = this.optionTypes[type];
    if (optionValues === undefined) return value;

    const matches = optionValues.filter(q => q[property] === value);
    if (matches.length > 0) {
      return matches[0][returnProperty] || value;
    }

    return value;
  }
}
